import {useEffect, useState} from "react";
import {GetLoginsForBusinessRequest, GetLoginsForBusinessResponse, IApiProviderProto} from "../../provider_api";
import {useRpcSender} from "../RpcSender";
import {useProviderProfile} from "../../ProviderProfileProvider";
import {RpcState} from "../RpcState";
import {useImpersonation} from "../../App/AdminHeader/AdminUtils";

export const useBusinessLogins = (props: {forAdminHeader?: boolean}) => {

  const rpcSender = useRpcSender();
  const {business, authenticatedUserRoles} = useProviderProfile();

  const [rpcState, setRpcState] = useState<RpcState>({state: "none"});
  const [logins, setLogins] = useState<IApiProviderProto[]>();

  const impersonation = useImpersonation()
  
  useEffect(() => {

    if (props.forAdminHeader && authenticatedUserRoles.indexOf('admin') < 0) {
      return;
    }
    
    const request = new GetLoginsForBusinessRequest({
      forAdminHeader: props.forAdminHeader
    });
    
    setRpcState({state: 'pending'});
    setLogins(undefined);
    
    rpcSender.send('get_logins', GetLoginsForBusinessRequest.encode(request).finish())
        .then(r => {
          const response = GetLoginsForBusinessResponse.decode(r);
          if (!response.okay) {
            setRpcState({state: 'error', message: 'unknown error fetching login'});
            return;
          }

          setLogins(response.provider);
          setRpcState({state: 'success'});

        })
        .catch(e => {
          setRpcState({state: 'error', message: e});
        })
  }, [business, impersonation]);

  return {rpcState, logins};
  
}